/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Compare_Col_CadcraftInputs */

const en_cad_compare_col_cadcraft = /** @type {(inputs: Cad_Compare_Col_CadcraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CADCraft`)
};

/**
* | output |
* | --- |
* | "CADCraft" |
*
* @param {Cad_Compare_Col_CadcraftInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_compare_col_cadcraft = /** @type {((inputs?: Cad_Compare_Col_CadcraftInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Compare_Col_CadcraftInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_compare_col_cadcraft(inputs)
});
export { cad_compare_col_cadcraft as "cad.compare.col_cadcraft" }